import * as React from "react";
export var StructureContext = React.createContext({}); // export function DynamicFactoryContext<
//   T extends DynamicStructureType = typeof defaultStructure,
// >() {
//   return React.createContext<StructureContextValue<T>>({
//     structure: defaultStructure as DynamicStructureNode<T>,
//     dynamicValues: {},
//     renderers: {},
//     lookup: {},
//   });
// }

export function useStructureContext() {
  var ctx = React.useContext(StructureContext);
  if (!ctx) throw new Error("Cannot use useStructureContext outside of a StructureContext provider.");
  return ctx;
}
export var NodeStateContext = React.createContext("unselected");